import { Component, OnInit } from '@angular/core';
import { EnforcementService } from 'src/app/Services/enforcement.service';
import { PermissionsService } from 'src/app/Services/permissions.service';
import { DataListFilterColumn, DatalastviewTextAndConditionalSuffixColumn, Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-citationtemplates',
    templateUrl: './citationtemplates.component.html',
    styleUrls: ['./citationtemplates.component.scss'],
    standalone: false
})
export class CitationTemplatesComponent implements OnInit {
  constructor(private permissionsService: PermissionsService, public enforcementService: EnforcementService) { }

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("ID", "Id"),
    new Datalistviewcolumn("Name", "Name"),
    new Datalistviewcolumn("Description", "Description"),
  ];

  async ngOnInit(): Promise<void> {
  }
} 
